module.exports = {
  'AD': 'US',
  'AE': 'US',
  'AF': 'US',
  'AG': 'US',
  'AI': 'US',
  'AL': 'EU2',
  'AM': 'US',
  'AO': 'US',
  'AQ': 'US',
  'AR': 'EU2',
  'AS': 'US',
  'AT': 'EU1',
  'AU': 'EU2',
  'AW': 'US',
  'AX': 'US',
  'AZ': 'US',
  'BA': 'EU2',
  'BB': 'US',
  'BD': 'US',
  'BE': 'EU2',
  'BF': 'US',
  'BG': 'EU2',
  'BH': 'US',
  'BI': 'US',
  'BJ': 'US',
  'BL': 'US',
  'BM': 'US',
  'BN': 'US',
  'BO': 'US',
  'BQ': 'US',
  'BR': 'EU2',
  'BS': 'US',
  'BT': 'US',
  'BV': 'US',
  'BW': 'US',
  'BY': 'US',
  'BZ': 'US',
  'CA': 'EU2',
  'CC': 'US',
  'CD': 'US',
  'CF': 'US',
  'CG': 'US',
  'CH': 'EU1',
  'CI': 'US',
  'CK': 'US',
  'CL': 'EU2',
  'CM': 'US',
  'CN': 'EU1',
  'CO': 'US',
  'CR': 'US',
  'CU': 'US',
  'CV': 'US',
  'CW': 'US',
  'CX': 'US',
  'CY': 'EU1',
  'CZ': 'EU2',
  'DE': 'EU1',
  'DJ': 'US',
  'DK': 'EU2',
  'DM': 'US',
  'DO': 'US',
  'DZ': 'US',
  'EC': 'US',
  'EE': 'EU2',
  'EG': 'US',
  'EH': 'US',
  'ER': 'US',
  'ES': 'EU1',
  'ET': 'US',
  'FI': 'EU2',
  'FJ': 'US',
  'FK': 'US',
  'FM': 'US',
  'FO': 'EU2',
  'FR': 'EU1',
  'GA': 'US',
  'GB': 'EU2',
  'GD': 'US',
  'GE': 'US',
  'GF': 'US',
  'GG': 'EU2',
  'GH': 'US',
  'GI': 'EU2',
  'GL': 'US',
  'GM': 'US',
  'GN': 'US',
  'GP': 'US',
  'GQ': 'US',
  'GR': 'EU2',
  'GS': 'US',
  'GT': 'US',
  'GU': 'US',
  'GW': 'US',
  'GY': 'US',
  'HK': 'EU1',
  'HM': 'US',
  'HN': 'US',
  'HR': 'EU2',
  'HT': 'US',
  'HU': 'EU2',
  'ID': 'US',
  'IE': 'EU2',
  'IL': 'EU2',
  'IM': 'US',
  'IN': 'US',
  'IO': 'US',
  'IQ': 'US',
  'IR': 'US',
  'IS': 'EU2',
  'IT': 'EU1',
  'JE': 'EU2',
  'JM': 'US',
  'JO': 'US',
  'JP': 'EU2',
  'KE': 'US',
  'KG': 'US',
  'KH': 'US',
  'KI': 'US',
  'KM': 'US',
  'KN': 'US',
  'KP': 'US',
  'KR': 'EU1',
  'KW': 'US',
  'KY': 'US',
  'KZ': 'US',
  'LA': 'US',
  'LB': 'US',
  'LC': 'US',
  'LI': 'EU2',
  'LK': 'US',
  'LR': 'US',
  'LS': 'US',
  'LT': 'EU2',
  'LU': 'EU2',
  'LV': 'EU2',
  'LY': 'US',
  'MA': 'US',
  'MC': 'EU2',
  'MD': 'EU2',
  'ME': 'US',
  'MF': 'US',
  'MG': 'US',
  'MH': 'US',
  'MK': 'EU2',
  'ML': 'US',
  'MM': 'US',
  'MN': 'US',
  'MO': 'US',
  'MP': 'US',
  'MQ': 'US',
  'MR': 'US',
  'MS': 'US',
  'MT': 'EU2',
  'MU': 'US',
  'MV': 'US',
  'MW': 'US',
  'MX': 'EU2',
  'MY': 'EU2',
  'MZ': 'US',
  'NA': 'US',
  'NC': 'US',
  'NE': 'US',
  'NF': 'US',
  'NG': 'US',
  'NI': 'US',
  'NL': 'EU2',
  'NO': 'EU2',
  'NP': 'US',
  'NR': 'US',
  'NU': 'US',
  'NZ': 'US',
  'OM': 'US',
  'PA': 'US',
  'PE': 'US',
  'PF': 'US',
  'PG': 'US',
  'PH': 'US',
  'PK': 'US',
  'PL': 'EU1',
  'PM': 'US',
  'PN': 'US',
  'PR': 'US',
  'PS': 'US',
  'PT': 'EU2',
  'PW': 'US',
  'PY': 'US',
  'QA': 'US',
  'RE': 'US',
  'RO': 'EU1',
  'RS': 'EU2',
  'RU': 'EU1',
  'RW': 'US',
  'SA': 'US',
  'SB': 'US',
  'SC': 'US',
  'SD': 'US',
  'SE': 'EU2',
  'SG': 'EU2',
  'SH': 'US',
  'SI': 'EU2',
  'SJ': 'US',
  'SK': 'EU2',
  'SL': 'US',
  'SM': 'US',
  'SN': 'US',
  'SO': 'US',
  'SR': 'US',
  'SS': 'US',
  'ST': 'US',
  'SV': 'US',
  'SX': 'US',
  'SY': 'US',
  'SZ': 'US',
  'TC': 'US',
  'TD': 'US',
  'TF': 'US',
  'TG': 'US',
  'TH': 'US',
  'TJ': 'US',
  'TK': 'US',
  'TL': 'US',
  'TM': 'US',
  'TN': 'US',
  'TO': 'US',
  'TR': 'US',
  'TT': 'US',
  'TV': 'US',
  'TW': 'US',
  'TZ': 'US',
  'UA': 'US',
  'UG': 'US',
  'UM': 'US',
  'US': 'US',
  'UY': 'US',
  'UZ': 'US',
  'VA': 'US',
  'VC': 'US',
  'VE': 'US',
  'VG': 'US',
  'VI': 'US',
  'VN': 'US',
  'VU': 'US',
  'WF': 'US',
  'WS': 'US',
  'XK': 'EU2',
  'YE': 'US',
  'YT': 'US',
  'ZA': 'US',
  'ZM': 'US',
  'ZW': 'US',
}
